<span *ngFor="let domainStandard of domainStandardSets; let i = index" class="domain-standard">
  <div *ngIf="!isEnvision" class="skill-text-container">
    <h3 class="skill-text">
      {{domainStandard.domainName}}
    </h3>
  </div>
  <span *ngFor="let scopeSequenceStandard of domainStandard.standardSets">
    <app-standard-result [index]="i + 1" [scopeSequenceStandard]="scopeSequenceStandard" [selectedSkillOption]="skillOrder" [skillOrder]="skillOrder"></app-standard-result>
  </span>
</span>
